/* eslint-disable */

/**
 * Filter Manager Class
 * Handles all filtering functionality for resources
 */
class FilterManager {
  constructor() {
    this.filters = {};
    this.filterClasses = [];
    
    // Constants
    this.SELECTORS = {
      card: '.hentry',
      filterBtn: '.btn-filter',
      filterClear: '.btn-filter.btn-filter-clear',
      filterCounter: '.filter-counter',
      countryFilter: '#country-filter',
      resourceList: '.resource-list',
      resource: '.resource',
      resourceEmpty: '.resource-empty',
      peopleTitle: '.people-section-title'
    };

    this.TAX_PREFIX = 'tax_';
    
    // Initialize URL params
    this.searchParams = new URLSearchParams(location.search);
    
    // Cache DOM elements
    this.$filterBtns = $(this.SELECTORS.filterBtn);
    this.$filterClear = $(this.SELECTORS.filterClear);
    this.$filterCounter = $(this.SELECTORS.filterCounter);
    this.$countryFilter = $(this.SELECTORS.countryFilter);
  }

  /**
   * Initialize filter functionality
   */
  init() {
    this.bindEvents();
    this.readUrlParams();
  }

  /**
   * Bind all event listeners
   */
  bindEvents() {
    // Taxonomy filter buttons
    this.$filterBtns.on('click touch', (e) => {
      e.preventDefault();
      this.handleFilterButtonClick($(e.currentTarget));
    });

    // Country filter dropdown
    this.$countryFilter.on('change', (e) => {
      this.handleCountryFilterChange($(e.currentTarget));
    });
  }

  /**
   * Handle filter button click
   * @param {jQuery} $button The clicked button
   */
  handleFilterButtonClick($button) {
    const thisTax = $button.data('tax');
    const thisTerm = $button.data('term');

    if (thisTerm === 'remove') {
      this.clearAllFilters();
      return;
    }

    // Initialize array for this taxonomy if it doesn't exist
    this.filters[thisTax] = this.filters[thisTax] || [];
    const termIndex = this.filters[thisTax].indexOf(thisTerm);

    $button.toggleClass('active');

    if (termIndex >= 0) {
      // Remove term if it exists
      this.filters[thisTax].splice(termIndex, 1);
      if (this.filters[thisTax].length === 0) {
        delete this.filters[thisTax];
      }
    } else {
      // Add new term
      this.filters[thisTax].push(thisTerm);
    }

    this.applyFilters();
  }

  /**
   * Handle country filter changes
   * @param {jQuery} $select The country select element
   */
  handleCountryFilterChange($select) {
    const selectedCountry = $select.val();
    
    if (selectedCountry) {
      this.filters['country'] = [selectedCountry];
    } else {
      delete this.filters['country'];
    }

    this.applyFilters();
  }

  /**
   * Clear all active filters
   */
  clearAllFilters() {
    this.filters = {};
    this.$filterBtns.removeClass('active');
    this.applyFilters();
  }

  /**
   * Apply all current filters
   */
  applyFilters() {
    this.updateFilterClearButton();
    this.filterResources();
    this.updateFilterInputs();
    this.updateUrlParams();
  }

  /**
   * Update filter clear button visibility
   */
  updateFilterClearButton() {
    const hasFilters = !$.isEmptyObject(this.filters);
    $('.filter-clear').toggleClass('d-none', !hasFilters);
  }

  /**
   * Filter resources based on current filters
   */
  filterResources() {
    this.filterClasses = [];
    const $cards = $(this.SELECTORS.card);
    const hasFilters = !$.isEmptyObject(this.filters);

    // Show/hide section title
    $(this.SELECTORS.peopleTitle).toggle(!hasFilters);

    if (!hasFilters) {
      $cards.show();
      return;
    }

    $cards.hide();

    // Handle country filter separately
    const countryFilter = this.filters['country'];
    delete this.filters['country'];

    // Process taxonomy filters
    Object.entries(this.filters).forEach(([tax, terms]) => {
      const taxonomy = tax.replace(this.TAX_PREFIX, '');
      
      if (this.filterClasses.length === 0) {
        terms.forEach(term => {
          this.filterClasses.push(`.${taxonomy}-${term}`);
        });
      } else {
        const currentClasses = [...this.filterClasses];
        this.filterClasses = [];
        
        currentClasses.forEach(existingClass => {
          terms.forEach(term => {
            this.filterClasses.push(`${existingClass}.${taxonomy}-${term}`);
          });
        });
      }
    });

    // If we have taxonomy filters, apply them first
    if (this.filterClasses.length > 0) {
      this.filterClasses.forEach(filterClass => {
        $(`${this.SELECTORS.card}${filterClass}`).show();
      });
    } else {
      // If we only have country filter, start with all cards visible
      $cards.show();
    }

    // Add country filter back and apply it
    if (countryFilter) {
      this.filters['country'] = countryFilter;
      
      // Hide cards that don't match the selected country
      $(`${this.SELECTORS.card}:visible`).each((_, element) => {
        const $element = $(element);
        if ($element.data('country') !== countryFilter[0]) {
          $element.hide();
        }
      });
    }

    // Show/hide empty state
    const hasVisibleResources = $(this.SELECTORS.resourceList)
      .find(`${this.SELECTORS.resource}:not(:hidden)`).length > 0;
    $(this.SELECTORS.resourceEmpty).toggleClass('d-none', hasVisibleResources);
  }

  /**
   * Update filter input states based on visible resources
   */
  updateFilterInputs() {
    const $visibleElements = $(`${this.SELECTORS.card}:visible`);
    
    // Disable all filter buttons initially
    this.$filterBtns.attr('disabled', 'disabled');

    // Enable buttons that have matching visible elements
    $visibleElements.each((_, element) => {
      Array.from(element.classList).forEach(className => {
        const parts = className.split('-');
        if (parts.length < 2) return;

        const selector = parts.length > 2
          ? `[data-tax="${this.TAX_PREFIX}${parts[0]}"][data-term="${parts[1]}-${parts[2]}"]`
          : `[data-tax="${this.TAX_PREFIX}${parts[0]}"][data-term="${parts[1]}"]`;

        this.$filterBtns.filter(selector).removeAttr('disabled');
      });
    });

    // Update counter if it exists
    this.$filterCounter.html($visibleElements.length);

    // Always enable clear button
    this.$filterClear.removeAttr('disabled');
  }

  /**
   * Update URL parameters based on current filters
   */
  updateUrlParams() {
    const newParams = new URLSearchParams();

    Object.entries(this.filters).forEach(([tax, terms]) => {
      terms.forEach(term => {
        if (newParams.has(tax)) {
          newParams.append(tax, term);
        } else {
          newParams.set(tax, term);
        }
      });
    });

    window.history.replaceState({}, '', `?${newParams}`);
    window.dispatchEvent(new Event('resize'));
  }

  /**
   * Read and apply filters from URL parameters
   */
  readUrlParams() {
    this.searchParams.forEach((value, key) => {
      if (key === 'country') {
        this.$countryFilter.val(value);
        this.filters[key] = [value];
      } else {
        const $button = this.$filterBtns.filter(`[data-tax=${key}][data-term=${value}]`);
        $button.addClass('active');
        
        this.filters[key] = this.filters[key] || [];
        this.filters[key].push(value);
      }
    });

    this.filterResources();
    this.updateFilterInputs();
  }
}

// Create and export filter manager instance
const filterManager = new FilterManager();

// Export required functions for backward compatibility
export function button_filter() {
  filterManager.init();
}

export function read_url_params() {
  filterManager.readUrlParams();
}



// WEBPACK FOOTER //
// ./scripts/functions/filters.js